import { createInjectionKey } from "../../_utils/index.mjs";
export const uploadInjectionKey = createInjectionKey('n-upload');